export default "__VITE_ASSET__CUqgXY33__"